import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { NodeNetwork } from 'src/app/core/models/nodeNetwork';
import { NodeService } from '../../../../core/services/node.service';
import { UpdateNodeComponent } from '../../modals/update-node/update-node.component';
import { AttachGatewayComponent } from './modals/attach-gateway/attach-gateway.component';
import { DetachGatewayComponent } from './modals/detach-gateway/detach-gateway.component';
import { Node } from 'src/app/core/models/node';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { UserRoleNames } from '../../../../core/models/users';
import { Router } from '@angular/router';

@Component({
  selector: 'app-node-network',
  templateUrl: './node-network.component.html',
  styleUrls: ['./node-network.component.scss']
})
export class NodeNetworkComponent implements OnInit {

  selectedNode: Node;
  nodeNetwork: NodeNetwork = {
    name:"",
    privateIp: 'fetching...',
    publicIp: 'fetching...',
    ipType: 'fetching...',
    dns: 'fetching...',
    macAddress: 'fetching...',
    gatewayName: 'fetching...',
    NewMachineName: ""
  }
  isMonitor: boolean = this.authenticationService.currentUserValue.role == UserRoleNames.Reader ? true : false;

  constructor(private dialog: MatDialog,
    private nodeService: NodeService,
    private _snackbar: MatSnackBar,
    private authenticationService: AuthenticationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.nodeService.SelectedNode.pipe(take(1)).subscribe(x => {
      if (x) {
        this.selectedNode = x;
        this.getNetworkInfo();
      }
    });
  }

  getNetworkInfo(){
    this.nodeService.getNodeNetworkInfo(this.selectedNode.vmName).subscribe({
      next: (data) => {
        this.nodeNetwork = JSON.parse(JSON.stringify(data));
      },
      error: (err) => {

      }
    })
  }

  attachGateway() {
    const dialogRef = this.dialog.open(AttachGatewayComponent, {
      autoFocus: false,
      disableClose: false,
      width: '25%',
      data: {
        oldGw: this.nodeNetwork.gatewayName,
        nodeName: this.selectedNode.vmName
      }
    })
  }

  detachGateway() {
    const dialogRef = this.dialog.open(DetachGatewayComponent, {
      autoFocus: false,
      disableClose: false,
      width: '25%',
      data: {
        titleMessage: "Detach Gateway",
        bodyMessage: `Do you want to detach ${this.nodeNetwork?.gatewayName} from ${this.selectedNode.vmName}.`,
        cancelText: "No",
        submitText: "Yes",
        nodeName: this.selectedNode.vmName
      }
    })
  }

  updateNetwork(){
    if(this.nodeNetwork.ipType == "fetching..."){
      this._snackbar.open("Fetching data, please wait...", "Ok", {
        duration: 5000
      });
      return;
    }
    const dialogRef = this.dialog.open(UpdateNodeComponent, {
      autoFocus: false,
      disableClose: true,
      width: '25%',
      data: {
        nodeInfo: this.selectedNode,
        nodeNetwork: this.nodeNetwork,
        depName: !this.selectedNode.depName ? this.selectedNode.allDeploymentsList : this.selectedNode.depName
      }
    }).afterClosed().subscribe(res => {
      if(res) {
        this.getNetworkInfo();
      } 
    })
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
